module.exports = __webpack_public_path__ + "9837477767977306beaec6be8d594b62.fbx";